import { render } from "./tablistView.vue?vue&type=template&id=708c408c"
import script from "./tablistView.vue?vue&type=script&lang=js"
export * from "./tablistView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__